import { render } from "./TeacherNewForm.vue?vue&type=template&id=662c4daa&scoped=true"
import script from "./TeacherNewForm.vue?vue&type=script&lang=js"
export * from "./TeacherNewForm.vue?vue&type=script&lang=js"

import "./TeacherNewForm.vue?vue&type=style&index=0&id=662c4daa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662c4daa"]])

export default __exports__